export default "__VITE_ASSET__C$t8DM9f__"